/**
 * Decision 65: a journal entry has no number until it is posted, and the API
 * returns `null` for one that has none. The sentence is the whole label, not
 * a placeholder number, and it is not set in the mono face — it is not a
 * number. Decision 69 adds the one exception: a voided entry that was never
 * posted says so instead of borrowing the Draft sentence. The wording is
 * fixed by the decisions, so it is not a catalog key.
 */
export const DRAFT_ENTRY_NUMBER = "Draft — number assigned on posting";
export const VOIDED_ENTRY_NUMBER = "Voided — no number assigned";

/** The exact label, shared by the number cells and the detail breadcrumb. */
export function entryNumberLabel(
  value: string | null,
  status?: string,
): string {
  if (value !== null) return value;
  return status === "Voided" ? VOIDED_ENTRY_NUMBER : DRAFT_ENTRY_NUMBER;
}

/** An entry number cell: the real number in mono, or the honest sentence. */
export function EntryNumber({
  value,
  status,
}: {
  value: string | null;
  status?: string;
}) {
  return value === null ? (
    <>{entryNumberLabel(value, status)}</>
  ) : (
    <span className="atlas-mono">{value}</span>
  );
}
